module.exports = __webpack_public_path__ + "img/img-1-parent-2x.87129e1.png";